// extracted by mini-css-extract-plugin
export var errorIcon = "_ob-1";
export var nameLogo = "_ob-0";